import { Route } from 'react-router-dom';
import { parrainageSchema } from './parrainage';
import Main from '@app/main/tables/Main';

/**
 * Routes configurées pour le module Parrainage
 */
const ParrainageRoutes = [
    // Route de liste (principale)
    <Route
        key="parrainages-list"
        path="parrainages"
        element={<Main key="parrainages-main" pageConfig={parrainageSchema} />}
    />,

    <Route
        key="parrainages-list"
        path="parrainages/*"
        element={<Main key="parrainages-main" pageConfig={parrainageSchema} />}
    />,
];

export default ParrainageRoutes;
